import * as ActionTypes from "../ActionTypes";

export const GetPayrollReportingEmployeeAction = (params) => ({
    type: ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_REQUEST,
    params
});

export const GetEmployeePostAdjustmentAction = (params) => ({
    type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_REQUEST,
    params
});

export const AddEmployeePostAdjustmentAction = (params) => ({
    type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_REQUEST,
    params
});

export const UpdateEmployeePostAdjustmentAction = (params) => ({
    type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_REQUEST,
    params
});

export const DeleteEmployeePostAdjustmentAction = (params) => ({
    type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_REQUEST,
    params
});

